import { loadScript } from '@/Utils/ScriptUtility';
import { reCaptchaProvider, externalScripts } from '@/Config';

const reCaptchaUrl = externalScripts.reCaptchaUrl;
const siteKey = reCaptchaProvider.siteKey;
const isEnabled = reCaptchaProvider.isEnabled;

export default class ReCaptchaProvider {
    isInitialized = false;

    async initAsync() {
        if (isEnabled) {
            try {
                const result = await loadScript(`${ reCaptchaUrl }?render=${ siteKey }`);
                if (result) {
                    this.isInitialized = true;
                }
            }
            catch {
                this.isInitialized = false;
            }
        }

        return this.isInitialized;
    }

    getTokenAsync(action) {
        if (!this.isInitialized || !window.grecaptcha?.enterprise) {
            return null;
        }

        return new Promise((resolve, reject) => {
            window.grecaptcha.enterprise.ready(() => {
                window.grecaptcha.enterprise.execute(siteKey, { action })
                    .then(resolve)
                    .catch(reject);
            });
        });
    }
}
